import { useGetRecipeTypes } from "@/hooks/useGetRecipeTypes";
import { RecipeType, recipeTypeFromPath } from "@/lib/types";
import { Recipes } from "@/pages/Recipes";
import { BrandLoader } from "@/components/BrandLoader";
import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

export const RecipeTypeRouteGuard = (): ReactNode => {
    const location = useLocation();
    const recipeType = recipeTypeFromPath(location.pathname);

    const { data, isPending, isError } = useGetRecipeTypes();

    if (!recipeType) {
        return <Navigate to="/recipes" replace />;
    }

    if (isPending) return <BrandLoader />;

    if (isError || !data) {
        return <Navigate to="/recipes" replace />;
    }

    const validRecipeType = data.find((type) => type.name === recipeType)?.name as RecipeType | undefined;

    return <Recipes key={validRecipeType} fixedType={validRecipeType} />;
};
